import { FC, memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import { HOME, ABOUT_US, CONTACT_US, MARKETPLACE } from './constants/routes';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Marketplace from './pages/Marketplace';

const AppRoutes: FC = () => {
  return (
    <Layout>
      <Routes>
        <Route path={HOME} element={<Home />} />
        <Route path={ABOUT_US} element={<About />} />
        <Route path={CONTACT_US} element={<Contact />} />
        <Route path={MARKETPLACE} element={<Marketplace />} />
      </Routes>
    </Layout>
  );
};

export default memo(AppRoutes);
